import { InjectionToken } from '@angular/core';

export const SESSION_EXPIRED_REDIRECT_URL = new InjectionToken<string>('SESSION_EXPIRED_REDIRECT_URL');
export const UNAUTHORIZED_URL_BLACKLIST = new InjectionToken<string>('UNAUTHORIZED_URL_BLACKLIST');
